<template>
  <div class="fill-height">
    <v-card
        height="100%"
        width="100%"
        class="d-flex flex-column rounded-lg"
        flat
    >
      <v-card-title class="text-break"><strong>{{ $t('cards.titles.upcomingEvents') }}</strong></v-card-title>
      <v-card-text v-if="isLoading" class="d-flex justify-center">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-card-text>
      <v-card-text v-if="!isLoading" class="fill-height py-0">
        <div v-if="!translatedActivities.length">{{ $t('cards.texts.noEvents') }}</div>
        <v-carousel
            dark
            v-if="translatedActivities.length"
            :continuous="true"
            :cycle="true"
            :show-arrows="true"
            hide-delimiters
            show-arrows-on-hover
            next-icon="fal fa-chevron-right"
            prev-icon="fal fa-chevron-left"
            delimiter-icon="fal fa-minus"
            light
            hide-delimiter-background
            :interval="10000"
            height="100%"
        >
          <template v-for="(event, n) in translatedActivities">
            <v-carousel-item
              v-if="(n + 1) % columns === 1 || columns === 1"
              :key="'event-slide-' + n"
              eager
          >
            <div class="col-12 ma-0 pa-0 d-flex flex-nowrap">
                <div v-for="(ndx, i) in columns" :key="'column-' + i" class="ma-0 pa-2 py-0" :class="'col-' + (12 / columns)">
                    <template v-if="(n + i) < translatedActivities.length">
                      <v-card class="pa-0" tile flat link height="100%" color="transparent" @click.prevent="openItem(translatedActivities[i+n])">
                        <v-img
                            v-if="translatedActivities[i+n].type === 'event' && translatedActivities[i+n].thumbnailUrl && translatedActivities[i+n].translation.thumbnailUrl"
                            :src="translatedActivities[i+n].translation.thumbnailUrl"
                            lazy-src="/assets/img/placeholder.png"
                            class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                            max-height="300"
                            max-width="100%"
                            cover
                            :aspect-ratio="16/9"
                            eager
                        >
                          <v-chip
                              v-if="translatedActivities[i+n].type"
                              class="ma-2 rounded-lg"
                              label
                              small
                              :color="translatedActivities[i+n].type === 'event' ? 'secondary' : translatedActivities[i+n].type === 'challenge' ? 'accent' : 'info'"
                              style="position: absolute; top: 0; right: 0;"
                          >
                            {{ $t('chips.' + translatedActivities[i+n].type) }}
                          </v-chip>
                        </v-img>
                        <v-img
                            v-else-if="translatedActivities[i+n].type === 'event' && translatedActivities[i+n].thumbnailUrl"
                            :src="translatedActivities[i+n].thumbnailUrl"
                            lazy-src="/assets/img/placeholder.png"
                            class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                            max-height="300"
                            max-width="100%"
                            cover
                            :aspect-ratio="16/9"
                            eager
                        >
                          <v-chip
                              v-if="translatedActivities[i+n].type"
                              class="ma-2 rounded-lg"
                              label
                              small
                              :color="translatedActivities[i+n].type === 'event' ? 'secondary' : translatedActivities[i+n].type === 'challenge' ? 'accent' : 'info'"
                              style="position: absolute; top: 0; right: 0;"
                          >
                            {{ $t('chips.' + translatedActivities[i+n].type) }}
                          </v-chip>
                        </v-img>
                        <v-img
                            v-else-if="translatedActivities[i+n].contentStructure && translatedActivities[i+n].contentStructure.asset && translatedActivities[i+n].contentStructure.asset.properties && translatedActivities[i+n].contentStructure.asset.properties.thumbnailUrl"
                            :src="translatedActivities[i+n].contentStructure.asset.properties.thumbnailUrl"
                            lazy-src="/assets/img/placeholder.png"
                            class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                            max-height="300"
                            max-width="100%"
                            cover
                            :aspect-ratio="16/9"
                            eager
                        >
                          <v-chip
                              class="ma-2 rounded-lg"
                              label
                              small
                              color="accent"
                              style="position: absolute; top: 0; right: 0;"
                          >
                            {{ $t('chips.challenge') }}
                          </v-chip>
                        </v-img>
                        <v-img
                            v-else
                            src="/assets/img/placeholder.png"
                            lazy-src="/assets/img/placeholder.png"
                            class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                            max-height="300"
                            max-width="100%"
                            cover
                            :aspect-ratio="16/9"
                            eager
                        >
                          <v-chip
                              v-if="translatedActivities[i+n].type"
                              class="ma-2 rounded-lg"
                              label
                              small
                              :color="translatedActivities[i+n].type === 'event' ? 'secondary' : translatedActivities[i+n].type === 'challenge' ? 'accent' : 'info'"
                              style="position: absolute; top: 0; right: 0;"
                          >
                            {{ $t('chips.' + translatedActivities[i+n].type) }}
                          </v-chip>
                        </v-img>
                        <v-card-text class="px-0">
                          <template v-if="translatedActivities[i+n].translation">
                            <div v-if="translatedActivities[i+n].translation.title"><strong>{{ translatedActivities[i+n].translation.title }}</strong></div>
                          </template>
<!--                          <div v-if="events[i+n].shortDescription" v-html="events[i+n].shortDescription"></div>-->
                        </v-card-text>
                      </v-card>
                    </template>
                </div>
            </div>
          </v-carousel-item>
          </template>
        </v-carousel>
      </v-card-text>
    </v-card>

    <!-- EVENT DIALOG -->
    <v-dialog
        v-model="showItemDialog"
        max-width="600"
        scrollable
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-img
            v-if="selectedItem.type && selectedItem.type === 'event' && selectedItem.translation && selectedItem.translation.thumbnailUrl"
            :src="selectedItem.translation.thumbnailUrl"
            lazy-src="/assets/img/placeholder.png"
            max-height="400"
            :aspect-ratio="16/9"
            class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
            eager
            cover
        ></v-img>
        <v-img
            v-else-if="selectedItem.type && selectedItem.type === 'event' && selectedItem.thumbnailUrl"
            :src="selectedItem.thumbnailUrl"
            lazy-src="/assets/img/placeholder.png"
            max-height="400"
            :aspect-ratio="16/9"
            class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
            eager
            cover
        ></v-img>
        <v-img
            v-else-if="selectedItem.contentStructure && selectedItem.contentStructure.asset && selectedItem.contentStructure.asset.properties && selectedItem.contentStructure.asset.properties.thumbnailUrl"
            :src="selectedItem.contentStructure.asset.properties.thumbnailUrl"
            lazy-src="/assets/img/placeholder.png"
            max-height="400"
            :aspect-ratio="16/9"
            class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
            eager
            cover
        ></v-img>
        <v-img
            v-else
            src="/assets/img/placeholder.png"
            lazy-src="/assets/img/placeholder.png"
            max-height="400"
            :aspect-ratio="16/9"
            class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
            eager
            cover
        ></v-img>
        <v-btn
            class="mt-3"
            color="primary"
            fab
            depressed
            dark
            small
            absolute
            right
            @click.prevent="showItemDialog = false"
        >
          <v-icon small>fal fa-close</v-icon>
        </v-btn>
        <v-card-text v-if="selectedItem.type && selectedItem.type === 'event' && selectedItem.translation" class="fill-height">
          <div class="text-break"><strong>{{ selectedItem.translation.title || '' }}</strong></div>
          <div v-if="selectedItem.translation.description" v-html="selectedItem.translation.description"></div>
        </v-card-text>
        <v-card-text class="fill-height pt-0" v-else-if="selectedItem.translation && (!selectedItem.type || selectedItem.type !== 'event')">
          <div class="text-break"><strong>{{ selectedItem.translation.title || '' }}</strong></div>
          <div v-if="selectedItem.translation.description" v-html="selectedItem.translation.description"></div>

          <div class="d-flex flex-wrap justify-space-between mt-2" v-if="selectedItem.properties && selectedItem.properties.challengeType && selectedItem.properties.challengeType === 'COMPETITION'">
            <div class="col-12 col-sm-6 ma-0 d-flex flex-nowrap justify-start align-center pa-0">
              <div class="mr-2">
                <v-sheet
                    width="60"
                    height="60"
                    min-height="60"
                    min-width="60"
                    color="primary lighten-2"
                    class="d-flex justify-center align-center rounded-lg"
                >
                  <v-icon color="primary" size="30">fal fa-calendar-days</v-icon>
                </v-sheet>
              </div>
              <div class="ml-2">
                <div class="text-break font-weight-black">{{ $t('labels.date') }}</div>
                <div class="primary--text font-weight-black">{{ $moment(selectedItem.properties.dataFrom).format('L') }}</div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-divider v-if="selectedItem.registrationModule || selectedItem.url || (selectedItem.translation && selectedItem.translation.url)"></v-divider>
        <v-card-actions class="justify-end mt-auto">
          <template v-if="selectedItem.registrationModule">
            <template v-if="!selectedItem.registrationModule.registered">
              <v-btn
                      color="primary"
                      depressed
                      class="rounded-lg"
                      :loading="registrationLoading"
                      :disabled="!(selectedItem.registrationModule.registerCount < selectedItem.registrationModule.maxParticipants) || !$moment(selectedItem.registrationModule.startRegistrationDate).isSameOrBefore($moment(), 'day') || !$moment(selectedItem.registrationModule.endRegistrationDate).isSameOrAfter($moment(), 'day')"
                      @click.prevent="checkConsentAndRegisterForEvent()"
              >
                  {{ $t('buttons.register') }}
              </v-btn>
            </template>
            <template v-if="selectedItem.registrationModule.registered">
              <v-btn
                      color="primary"
                      depressed
                      class="rounded-lg"
                      :loading="registrationLoading"
                      :disabled="!$moment(selectedItem.registrationModule.startRegistrationDate).isSameOrBefore($moment(), 'day') || !$moment(selectedItem.registrationModule.endRegistrationDate).isSameOrAfter($moment(), 'day')"
                      @click.prevent="deleteRegistrationForEvent()"
              >
                  {{ $t('buttons.deregister') }}
              </v-btn>
            </template>
          </template>
          <template v-else-if="selectedItem.translation && selectedItem.translation.url">
            <v-btn
                    color="primary"
                    depressed
                    class="rounded-lg"
                    @click.prevent="navigate(selectedItem.translation.url)"
            >
                {{ $t('buttons.participate') }}
            </v-btn>
          </template>
          <v-btn
              v-if="!selectedItem.type || selectedItem.type !== 'event'"
              color="primary"
              depressed
              class="rounded-lg"
              @click.prevent="navigate('/challenges/' + selectedItem.identifier)"
          >
            {{ $t('buttons.details') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
import api from "@/api/api";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "m2h-upcoming-events",
  data() {
    return {
      isLoading: true,
      events: [],
      showItemDialog: false,
      selectedItem: {},
      registrationLoading: false,
      acceptConsent: false,
      consent: {},
      consentDialogIdentifier: ''
    }
  },

  computed: {
    columns() {
        if (this.$vuetify.breakpoint.xl) {
            return 6;
        }

        if (this.$vuetify.breakpoint.lg) {
            return 4;
        }

        if (this.$vuetify.breakpoint.md) {
            return 3;
        }

        if (this.$vuetify.breakpoint.sm) {
            return 2;
        }

        if (this.$vuetify.breakpoint.sm) {
          return 1;
        }

        return 1;
    },

    translatedActivities() {
      let activities = [...this.events]
      activities.forEach((activity) => {
        if (!activity.type || activity.type !== 'event'){
          activity.translation = null
          if (activity.contentStructure && activity.contentStructure.asset && activity.contentStructure.asset.assetTranslations.length){
            if (activity.contentStructure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)){
              activity.translation = activity.contentStructure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)
            }
          }
        }
        if (activity.type || activity.type == 'event'){
          activity.translation = null
          if (activity.translations && activity.translations.length){
            activity.translation = activity.translations.find((t) => t.language === this.$i18n.locale)
          }
        }
      })
      return activities.filter((a) => a.translation)
    }
  },

  mounted(){
    this.fetchEvents()
    this.$root.$on('handle-consent-dialog', (data) => {
      if (data.consentDialogIdentifier === this.consentDialogIdentifier){
        this.registerForEvent()
      }
    })
  },

  methods: {
    async fetchEvents(){
      this.isLoading = true
      let lang = localStorage.getItem('Lang') || this.$i18n.locale
      let events = []
      events = await api.newsItems.getList("event", lang).then((res) => { return res.data })
      let happenings = await api.happenings.getList().then((res) => { return res.data })
      happenings = happenings.map((h) => ({
        ...h, type: 'event'
      }))
      let challenges = await api.challenges.getList().then((res) => { return res.data })
      // let challenges = await api.newsItems.getList("challenge", lang).then((res) => { return res.data })
      events = happenings.concat(challenges)
      /*let news = await api.newsItems.getList("newsfeed", this.$i18n.locale).then((res) => { return res.data })
      events = events.concat(news)*/
      if (events.length){
        this.events = events.sort((a, b) => {
          let aDate = a.visibleFrom
          let bDate = b.visibleFrom
          return this.$moment(bDate).unix() - this.$moment(aDate).unix()
        })
      }
      this.isLoading = false
    },

    async fetchImage(id){
      if (id){
        return await api.newsItems.getSas(id)
            .then((res) => {
              return res.data
            })
            .catch(() => {
              return ''
            }) 
      } else {
        return ''
      }
    },

    async openItem(item){
      this.selectedItem = item
      if (item.registrationModule && item.registrationModule.identifier){
          this.selectedItem.registrationModule.registered = await api.userRegistrations.getRegistrationExists(item.registrationModule.identifier).then((res) => {
              return res.data
          })
          await this.updateRegisterCount()
      }
      
      this.showItemDialog = true
      if (item.type === 'event'){
        this.$root.$emit('post-event-opened', { id: item.identifier })
      } else if (item.type === 'challenge'){
        this.$root.$emit('post-challenge-opened', { id: item.identifier })
      }
    },
      
    async registerForEvent(){
        this.registrationLoading = true
        await this.updateRegisterCount()
        if (this.selectedItem.registrationModule.registerCount < this.selectedItem.registrationModule.maxParticipants){
            let registration = await api.userRegistrations.postRegistrationRegister(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
            if (registration.identifier){ 
                this.selectedItem.registrationModule.registered = true
                await this.updateRegisterCount()
                this.$root.$emit('open-snackbar', { mode: "registered", title: this.selectedItem.translation ? this.selectedItem.translation.title : this.selectedItem.title })
            }
        }
        this.registrationLoading = false
    },
      
    async updateRegisterCount(){
        this.selectedItem.registrationModule.registerCount = await api.userRegistrations.getRegistrationCount(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
    },

    async deleteRegistrationForEvent(){
        this.registrationLoading = true
        let registration = await api.userRegistrations.getRegistration(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
        if (registration.identifier){
            await api.userRegistrations.deleteRegistration(registration.identifier)
            this.selectedItem.registrationModule.registered = false
            this.$root.$emit('open-snackbar', { mode: "deregistered", title: this.selectedItem.translation ? this.selectedItem.translation.title : this.selectedItem.title })
        }
        await this.updateRegisterCount()
        this.registrationLoading = false
    },

    async checkConsent(){
        this.consent = await api.consent.getForLabel(this.selectedItem.registrationModule.consentLabel).then((res) => { return res.data })
        this.acceptConsent = this.consent.approved
    },

    async checkConsentAndRegisterForEvent(){
        this.registrationLoading = true
        await this.checkConsent()
        if (this.acceptConsent){
            await this.registerForEvent()
        } else {
          this.consentDialogIdentifier = uuidv4();
          this.$root.$emit('open-consent-dialog', { consentDialogIdentifier: this.consentDialogIdentifier, consentLabel: this.selectedItem.registrationModule.consentLabel })
        }
        this.registrationLoading = false
    },

    navigate(route){
      //window.location.href = route
      if (route){
        window.open(route, '_blank'); 
      }
    },
  }
}
</script>

<style scoped>

</style>
